import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { InputContainer } from '@r1-frontend/ui-react/components/inputSimple/styles';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IOption } from '@r1-frontend/ui-react/components/select/creatableSelect';
import { CreatablePhoneSelect } from '@r1-frontend/ui-react/components/select/creatableSelect';

import { setClientContactPhone, setClientPhone } from '~/src/features/tariffBuilder/actions';
import { useCtxDispatch } from '~/src/features/tariffBuilder/hooks';
import { TState } from '~/src/store';

interface IProps {
    className?: string,
    fillPhone: string,
    contactPhone?: IOption,
}

const CreatablePhoneSelectWrapper = ({ fillPhone, contactPhone, className }: IProps): JSX.Element => {
    const dispatch = useCtxDispatch();

    const phones = useSelector((state: TState) => state.auth.clientContacts?.phone);

    const onChangePhone = (option: IOption) => {
        dispatch(setClientContactPhone(option));
    };

    const onFillPhone = (option: IOption) => {
        dispatch(setClientPhone(option.value));
    };

    const phoneOptions:IOption[] = useMemo(() => {
        return (phones || []).map(item => ({ label: item.value, value: `${item.id}`, isContactId: true }));
    }, [phones]);

    return (
        <div className={className}>
            <CreatablePhoneSelect
                options={phoneOptions}
                onChange={onChangePhone}
                value={contactPhone}
                inputValue={fillPhone}
                onInputChange={onFillPhone}
                createLabel='Указать новый номер'
                placeholder='Выберите возможный вариант'
                inputPlaceHolder='Введите номер телефона'
                data-test='ContactsPage__phoneSelect'
            />
        </div>
    );
};

export default styled(CreatablePhoneSelectWrapper)`
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    width: 100%;
    > div {
        @media (min-width: ${wideBreakpoints.mobile}) {
            max-width: 256px;
        }
    }
    & ${InputContainer},
    & ${InputContainer} + div {
        margin: 0;
        @media (min-width: ${wideBreakpoints.mobile}) {
            max-width: 256px;
        }
    }
`;
